<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue:  { type: Array,  default: () => [] },
  label:       { type: String, default: '' },
  placeholder: { type: String, default: '' },
  hint:        { type: String, default: '' }
})
const emit = defineEmits(['update:modelValue'])

// Always show at least one (empty) row so the control is never blank.
const rows = computed(() => (props.modelValue.length ? props.modelValue : ['']))

function update(i, value) {
  const base = props.modelValue.length ? props.modelValue : ['']
  const next = base.slice()
  next[i] = value
  emit('update:modelValue', next)
}
function add() {
  emit('update:modelValue', [...props.modelValue, ''])
}
function remove(i) {
  const next = props.modelValue.slice()
  next.splice(i, 1)
  emit('update:modelValue', next)
}

const inputBase = 'w-full rounded-[var(--radius-md)] border border-[color:var(--line)] bg-[color:var(--surface)] text-[color:var(--ink)] px-3 py-2 text-sm focus:outline-2 focus:outline-[color:var(--accent)]'
</script>

<template>
  <div>
    <label v-if="label" class="block text-sm font-medium text-[color:var(--inkSoft)] mb-1">{{ label }}</label>
    <div class="flex flex-col gap-2">
      <div v-for="(row, i) in rows" :key="i" class="flex items-center gap-2">
        <input
          type="text"
          :value="row"
          :placeholder="placeholder"
          :class="inputBase"
          @input="update(i, $event.target.value)"
        >
        <button
          type="button"
          class="shrink-0 w-8 h-8 grid place-items-center rounded-[var(--radius-md)] border border-[color:var(--line)] text-[color:var(--muted)] hover:text-[color:var(--danger)]"
          :aria-label="$t('vendor_portal.tour_form.remove_item')"
          @click="remove(i)"
        >×</button>
      </div>
    </div>
    <button
      type="button"
      class="mt-2 inline-flex items-center gap-1 text-sm font-medium text-[color:var(--accent)]"
      @click="add"
    >+ {{ $t('vendor_portal.tour_form.add_item') }}</button>
    <p v-if="hint" class="mt-1 text-xs text-[color:var(--muted)]">{{ hint }}</p>
  </div>
</template>
